import agendaReducer from './agenda'
import appReducer from './app'
import axiosReducer from './axios'
import confirmReducer from './confirm'
import formReducer from './form'
import messageReducer from './message'
import printReducer from './print'
import sidebarReducer from './sidebar'
import notificationReducer from './notification'
import processingReducer from './processing'

const reducers = {
  agenda: agendaReducer,
  app: appReducer,
  axios: axiosReducer,
  confirm: confirmReducer,
  form: formReducer,
  message: messageReducer,
  print: printReducer,
  sidebar: sidebarReducer,
  notification: notificationReducer,
  processing: processingReducer,
}

export default reducers
